import { type IDocumento } from '@/interfaces/model/don.interface';
import { type ILookup } from '@/interfaces/model/generic.interface';

export type Form = {
	nifEmisor: string;
	idError: number;
	idTramite: number;
	idTipoError: number;
	numeroTramite: string;
	fechaCreacion: string;
	fechaSubsanacion: string;
	estado: ILookup;
	observacionesPeticion: string;
	tipoDocumento: string;
	observacionesSubsanacion: string;
	documentoSubsanado?: IDocumento;
};

export const defaultValues = {
	nifEmisor: '',
	numeroTramite: '',
	fechaCreacion: undefined,
	observacionesPeticion: '',
	observacionesSubsanacion: '',
	documentoSubsanado: undefined,
	tipoDocumento: ''
};